import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { debug, download, file, swalAlert } from '../../utils';
import API from '../../api';
import { useSelector } from 'react-redux';
import AdminOrdersList from './../orders/admin/AdminOrdersList';
import AdminOrdersChart from './../orders/admin/AdminOrdersChart';
import AdminHomeUpdate from '../products/admin/AdminHomeUpdate'
import QRCodeGenerator from '../products/admin/QRCodeGenerator';
import { FaCircle } from 'react-icons/fa';
import './admin-home.css';
function AdminHome() {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);
  return (
    <div id="admin-home" className='container'>
      <div className="row">
        <div className="main col-lg-8">
          <div className="module mb-4 border border-gray-9 " >
            <h4 className="">Dernières commandes</h4>
            <AdminOrdersList
              year={new Date().getFullYear()}
              limit={25}
              title={false}
              selector={false}
              thead={false}
              columns={['orderDate', 'orderRef', 'customer', 'articles', 'orderTotalPriceIT', 'download']}
            /></div>
        </div>
        <div className="side col mb-5">
          {config?.tenant?.backoffice?.apps.includes('catalog') && config?.tenant?.backoffice?.home_modules.includes('catalog_update') &&
            <div className="module border border-gray-9 mb-4   bg-gray-e">
              <AdminHomeUpdate />
            </div>
          }
          {config?.tenant?.backoffice?.home_modules.includes('qrcode_gen') &&
            <div className="module border border-gray-9 mb-4 bg-gray-e">
              <QRCodeGenerator />
            </div>
          }
          <div className="module border border-gray-9 mb-4 bg-gray-e">
            <div className="content fs-8">
              {config?.tenant?.backoffice?.apps.includes('customers') && config?.tenant?.backoffice?.home_modules.includes('customer_add') &&

                <p className="my-2"><FaCircle size={6} className="me-2" /><Link className="text-brand-primary" to="/extradmin/customers/new">Ajouter un compte client</Link></p>
              }

              {config?.tenant?.backoffice?.apps.includes('catalog') && config?.tenant?.backoffice?.home_modules.includes('product_add') &&
                <p className="my-2"><FaCircle size={6} className="me-2" /><Link className="text-brand-primary" to="/extradmin/products/new">Ajouter un produit</Link></p>
              }
            </div>
          </div>
        </div>
      </div>
      {debug(config.tenant)}
    </div >);
}
export default AdminHome;
